export default {
	background: 'black',
	accent: '#4106CC',
	color: '#fffff7',
	complementary: '#999999',
	clearcolor: '#fffff7',
	redCure: '#B42223',
	darkcolor: 'black',
	fontbody: '"Lora", Helvetica, Arial, sans-serif',
	fonttitle: '"Special Elite", Helvetica, Arial, sans-serif',
	fonttitle2: '"Special Elite", Helvetica, Arial, sans-serif',
	fonttitle3: '"Special Elite", Helvetica, Arial, sans-serif',
	fonttitlesize: '2.5rem',
	fontsize: '1.5rem',
	lineheight: '1.42857',
	normalWidth: '680px',
	maxWidth: '1200px',
	overWidth: '1440px',
	button: {
		backgroundColor: '#fffff7',
		color: 'black',
		borderRadius: '4px',
		padding: '1rem 2rem'
	}
};
